<template>
  <div class="course-item" shadow="hover" @click.native="onClickItem">
    <div class="flex-course">
      <div class="flex-cover">
        <div class="cover-wrap">
          <img class="cover" :src="course.cover_img" />
        </div>
        <div style="width: 100%">
          <div class="title">{{ course.title }}</div>
          <div class="font-style teacher">
            <span>讲师：</span>
            <span v-for="(teacher, index) in course.teachers" :key="index">
              <span>{{ teacher.teacher_name }}</span>
              <span v-if="index != course.teachers.length - 1">
                {{ " / " }}
              </span>
            </span>
          </div>
          <div class="font-style time">
            {{ course.start_play_date }} - {{ course.end_play_date }}
          </div>
          <div class="btn-groud">
            <span class="btn" @click="onComment">
              {{ course.is_comment == 1 ? "查看评价" : "评价课程" }}
            </span>
            <span class="btn" @click="toCourse">查看详情</span>
            <span class="btn study" @click="onPlay">
              {{ course.play_type > 2 ? "查看回放" : "立即学习" }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OpenCourseItem",
  props: {
    course: {},
  },
  methods: {
    onComment() {
      this.$emit("onComment", this.course);
    },
    toCourse() {
      this.$router.push({
        name: "CourseShow",
        params: {
          id: this.course.id,
        },
        query: {
          recommend: 3,
          title: "公开课",
        },
      });
    },
    async onPlay() {
      if (this.course.limit == 1) {
        this.$message.warning("您已被限制访问，请联系管理员");
        return;
      }
      this.$livePlay(this.course.id, this.course.course_type, {
        id: 0,
        title: this.course.title,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.course-item {
  padding: 24px 0;
  border-bottom: 1px solid #e6e6e6;
  position: relative;
  .flex-course {
    .flex-cover {
      display: flex;
      .cover-wrap {
        width: 210px;
        margin-right: 18px;
        overflow: hidden;
        flex-shrink: 0;
        border-radius: 6px;
      }
      .cover {
        border-radius: 6px;
        width: 100%;
        height: 100%;
        transform: scale(1);
        transition: 0.5s all;
      }
    }
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
  }
  .font-style {
    color: #666;
    font-size: 14px;
  }
  .teacher {
    margin-bottom: 8px;
  }
  .time {
    margin-bottom: 24px;
  }
  .btn-groud {
    width: 100%;
    text-align: right;
    .btn {
      padding: 8px 24px;
      color: #333333;
      border: 1px solid #b3b3b3;
      border-radius: 22px;
      margin-right: 12px;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
      &:hover {
        border: 1px solid #bb1c20;
        color: #bb1c20;
      }
    }
    .study {
      background-color: $primary-color;
      border-color: $primary-color;
      color: #fff;
      &:hover {
        border: 1px solid #bb1c20;
        color: #fff;
      }
    }
  }
}
</style>
